<script setup>
import Dialog from 'primevue/dialog'
import { ref } from 'vue'
import { storeToRefs } from 'pinia'
import { useUserStore } from './../authentication/user.store'
import LicenseSelector from './LicenseSelector.vue'

const userStore = useUserStore()
const { showLicenseSelector, license } = storeToRefs(userStore)
const confirmDisabled = ref(true)
const selectedLicense = ref()

function onConfirm() {
  license.value = selectedLicense.value
}

function closeModal() {
  showLicenseSelector.value = false
}
</script>
<template>
  <Dialog
    v-model:visible="showLicenseSelector"
    modal
    :style="{ width: '50vw' }"
    header="Header"
    @hide="confirmDisabled = true"
  >
    <template #header>
      <h3 class="font-medium">Select License Type</h3>
    </template>
    <LicenseSelector
      :user-license="license"
      @license:confirmEnabled="
        ($event) => {
          confirmDisabled = !$event
        }
      "
      @license:changed="
        ($event) => {
          selectedLicense = $event
        }
      "
    />
    <template #footer>
      <button
        class="rounded-md bg-primary-400 p-4 text-white disabled:cursor-not-allowed disabled:opacity-65"
        @click="onConfirm"
        :disabled="confirmDisabled"
      >
        Confirm
      </button>
      <button class="border-gray-400 hover:bg-gray-400 rounded-md border-2 p-4" @click="closeModal">
        Cancel
      </button>
    </template>
  </Dialog>
</template>
<style type="text/css"></style>
